//angular
import { Component,  OnDestroy, OnInit, OnChanges, Renderer2, SimpleChanges } from '@angular/core';
import { Event, NavigationStart, Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
//app
import { StorageService } from '../../../../_core/services';
import { collectionOfNavOption } from '../../../../app.data';
import { navMobileAnimation } from '../../../../_shared/animations';
import { AuthService } from 'src/app/_core/services/auth.service';
import { Unsubscriber } from 'src/app/_shared/unsubscriber/unsubscriber';

@Component({
  selector: 'nav-mobile',
  templateUrl: './nav-mobile.component.html',
  animations: [navMobileAnimation],
})
export class NavMobileComponent implements OnChanges, OnInit, OnDestroy {
  clientY: any;
  collectionOfNavOption: Array<any> = collectionOfNavOption;
  companyName: string;
  navMobileStatus: number = 0;
  step: string = null;
  stepQuickAccess: string = 'quickAccess';
  stepSubscriptions: string = 'subscriptions';
  stepOrders: string = 'orders';
  stepCustomers: string = 'customers';
  stepInvoices: string = 'invoices';
  stepAnalytics: string = 'analytics';
  stepProducts: string = 'products';
  stepIntegrations: string = 'integrations';
  stepLogs: string = 'logs';
  stepSettings: string = 'settings';
  userFirstName: string;
  userLastName: string;
  userPicture: string;
  userRole: string;
  private subs = new Unsubscriber();

  constructor(
    private _auth: AuthService,
    private _iconRegistry: MatIconRegistry,
    private _sanitizer: DomSanitizer,
    private _renderer: Renderer2,
    private _router: Router,
    private _storage: StorageService
  ) {
    this._iconRegistry.addSvgIcon('ico-account',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-customers-01.svg'));
    this._iconRegistry.addSvgIcon('ico-analytics',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-analytics-01.svg'));
    this._iconRegistry.addSvgIcon('ico-back',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-back-01.svg'));
    this._iconRegistry.addSvgIcon('ico-close',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-close-01.svg'));
    this._iconRegistry.addSvgIcon('ico-company',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-company-03.svg'));
    this._iconRegistry.addSvgIcon('ico-customers',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-customers-02.svg'));
    this._iconRegistry.addSvgIcon('ico-dashboard',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-dashboard-02.svg'));
    this._iconRegistry.addSvgIcon('ico-home',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-dashboard-01.svg'));
    this._iconRegistry.addSvgIcon('ico-integrations',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-integrations-01.svg'));
    this._iconRegistry.addSvgIcon('ico-invoices',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-invoices-01.svg'));
    this._iconRegistry.addSvgIcon('ico-logs',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-logs-01.svg'));
    this._iconRegistry.addSvgIcon('ico-next',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-next-01.svg'));
    this._iconRegistry.addSvgIcon('ico-notifications',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-notifications-04.svg'));
    this._iconRegistry.addSvgIcon('ico-orders',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-orders-01.svg'));
    this._iconRegistry.addSvgIcon('ico-products',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-products-01.svg'));
    this._iconRegistry.addSvgIcon('ico-settings',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-settings-02.svg'));
    this._iconRegistry.addSvgIcon('ico-signout',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-logout-01.svg'));
    this._iconRegistry.addSvgIcon('ico-subscriptions',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-subscriptions-01.svg'));
    this._iconRegistry.addSvgIcon('ico-support',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-phone-01.svg'));
    this._iconRegistry.addSvgIcon('ico-switch',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-switch-01.svg'));
    this._iconRegistry.addSvgIcon('ico-user-account', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-customers-02.svg'));
    this._iconRegistry.addSvgIcon('logo-rebillia',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/logo-rebillia.svg'));
    this._iconRegistry.addSvgIcon('logo-rebillia-blue',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/logo-rebillia-blue.svg'));
    this._iconRegistry.addSvgIcon('logo-rebillia-white',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/logo-rebillia-white.svg'));

    this.userFirstName = this._storage.readLocalStorage('userFirstName');
    this.userLastName = this._storage.readLocalStorage('userLastName');
    this.userPicture = this._storage.readLocalStorage('userAvatar');
    this.companyName = this._storage.readLocalStorage('entityName');
    this.userRole = this._storage.readLocalStorage('userRole');

    // Close the mobile navigation overlay when navigation start.
    this.subs.addSub = this._router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        this.step = null;
        this.closeNav();
      }
    });
  }

  closeNav() {
    this._renderer.removeClass(document.body, 'nonscroll');
    this.step = null;
    this.navMobileStatus = 0;
  }

  disableRubberBand(event: any, overlay: any) {
    var clientY = event.targetTouches[0].clientY - this.clientY;

    if (overlay.scrollTop === 0 && clientY > 0) {
      //element is at the top of its scroll
      event.preventDefault();
    }

    if (this.isOverlayTotallyScrolled(overlay) && clientY < 0) {
      //element is at the top of its scroll
      event.preventDefault();
    }
  }

  lockScroll() {
    var overlay = document.getElementById('nav_mobile');
    overlay.addEventListener(
      'touchstart',
      (event) => this.onTouchStart(event),
      false
    );
    overlay.addEventListener(
      'touchmove',
      (event) => this.onTouchMove(event, overlay),
      false
    );
  }

  ngOnChanges(args: SimpleChanges) {
    // const _user: SimpleChange = args.user;
    // if (!_user.firstChange){
    //   this.user = _user.currentValue;
    //   this.userPicture = this.user.picture;
    //   this.userFullname = this.user.firstName;
    // }
  }

  ngOnInit() {}

  ngOnDestroy() {
    this._renderer.removeClass(document.body, 'nonscroll');
    this.subs.unsubscribe();
  }

  isOverlayTotallyScrolled(overlay) {
    return overlay.scrollHeight - overlay.scrollTop <= overlay.clientHeight;
  }

  onLogout() {
    this._auth.logout();
  }

  onTouchStart(event: any) {
    if (event.targetTouches.length === 1) {
      this.clientY = event.targetTouches[0].clientY;
    }
  }

  onTouchMove(event: any, overlay: any) {
    if (event.targetTouches.length === 1) {
      this.disableRubberBand(event, overlay);
    }
  }

  openNav() {
    this.lockScroll();
    this._renderer.addClass(document.body, 'nonscroll');
    this.step = null;
    this.navMobileStatus = 1;
  }

  setStep(_index: string) {
    this.step = _index;
  }
}
